import type { HelpFile } from '../../types/help'
import { ToasterTestIds } from '../../../testids/ToasterTestIds'

export const toasterHelp: HelpFile = {
  texts: {
    [ToasterTestIds.toast]: null,
    [ToasterTestIds.toastError]: null,
    [ToasterTestIds.toastEntityLink]: 'Jump to the conflicting record so you can review or edit its current value.',
    [ToasterTestIds.toastErrorLogLink]: 'Open the matching entry in the Error Log to see the full context and stack trace.',
  },
}
